import { Effect } from 'effect'

export function sha256(contents: Uint8Array): Effect.Effect<string> {
  // SHA-256 is universally supported by SubtleCrypto. Rejection is an
  // environment defect, not a recoverable file error.
  return Effect.promise(() => crypto.subtle.digest('SHA-256', Uint8Array.from(contents))).pipe(
    Effect.map((hashBuffer) =>
      Array.from(new Uint8Array(hashBuffer))
        .map((byte) => byte.toString(16).padStart(2, '0'))
        .join('')
    )
  )
}
